import { Component, OnInit } from '@angular/core';
// Forms
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-address-details',
  templateUrl: './address-details.component.html',
  styleUrls: ['./address-details.component.scss'],
})
export class AddressDetailsComponent  implements OnInit {

  /**
   * Variables
   */
  PilotForm: FormGroup;

  constructor(private rootFormGroup: FormGroupDirective) { }

  // #region --> LifeCycle

  /**
   * Every time the component is rendered, we take from the parent the pilot form.
   */
  ngOnInit() {
    this.PilotForm = this.rootFormGroup.control;
  }

  // #endregion --> LifeCycle

}
